import { useQueryClient } from "@tanstack/react-query"

import { TFetchPropertyContextsQuery } from "src/data/propertyContext/propertyContextTypes"

export const propertyContextQueryCache = {
  all() {
    return ["propertyContext"] as const
  },

  propertyContextLists() {
    return [...this.all(), "list"] as const
  },

  propertyContextList(orgId: string, filters?: TFetchPropertyContextsQuery) {
    if (filters) {
      return [...this.propertyContextLists(), orgId, filters] as const
    }

    return [...this.propertyContextLists(), orgId] as const
  },

  propertyContext(orgId: string, contextId: string) {
    return [...this.propertyContextList(orgId), contextId] as const
  },
}

export function usePropertyContextQueryCache() {
  const queryClient = useQueryClient()

  function invalidatePropertyContextList(orgId: string) {
    queryClient.invalidateQueries({
      queryKey: propertyContextQueryCache.propertyContextList(orgId),
    })
  }

  function invalidatePropertyContext(orgId: string, contextId: string) {
    queryClient.invalidateQueries({
      queryKey: propertyContextQueryCache.propertyContext(orgId, contextId),
    })
  }

  return {
    invalidatePropertyContextList,
    invalidatePropertyContext,
  }
}
